import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Avatar from 'components/Avatar/Avatar';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './ActivityCollapsedRow.module.scss';

const cn = classnames.bind(styles);

// One-line residue of an event collapsed by a quick reply: farm, group and a Show link
const ActivityCollapsedRow = ({ activity, onShow }) => {
  const { farm, company, pig_group, user } = activity;
  const title = farm?.name || company?.name || user?.full_name;

  return (
    <div className={cn('activity-collapsed-row')}>
      <Avatar type={farm ? 'farm' : 'company'} avatarSize={30} iconSize={14} />
      <div className={cn('residue')}>
        <strong className={cn('title')}>{title}</strong>
        {pig_group && <span className={cn('group')}>{pig_group.name}</span>}
      </div>
      <button type="button" className={cn('show-button')} onClick={onShow}>
        <FormattedMessage id="container.farmfeed.row.show" />
      </button>
    </div>
  );
};

ActivityCollapsedRow.propTypes = {
  activity: T.object.isRequired,
  onShow: T.func.isRequired,
};

export default ActivityCollapsedRow;
